import type { ReactNode } from "react";

interface PageMetaProps {
  title: string;
  description: string;
  keywords: string;
  path: string;
  children?: ReactNode;
}

export default function PageMeta({ title, description, keywords, path, children }: PageMetaProps) {
  const canonical =
    typeof window !== "undefined" ? `${window.location.origin}${path}` : path;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="高校吃瓜网" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {children}
    </>
  );
}